/*
 * YesBankTransactoinLimits actions
 */
import * as reqHandler from '../../config/services/serviceHandler';
import endpoint from '../../config/endPoints';
import {
  clearDefaultError, rootApiResponse,
} from '../HeaderContainer/actions';
import {
  DEFAULT_ACTION,
  FETCH_TRANSACTIONS_SUCCESS,
  SET_REPORT_STATEMENT_SUCCESS,
} from '../NetworkCards/constants';
import { utils } from '../../devUtils';
import { errorResponse } from '../../devUtils/commonUtils';

const fetchTransactionsSuccess = (payload) => ({ type: FETCH_TRANSACTIONS_SUCCESS, payload });
const yesRequestStatementGenerateSuccess = (payload) => ({ type: SET_REPORT_STATEMENT_SUCCESS, payload });

const fetchTransactions = (payload) => async (dispatch, getState, api) => {
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    const response = await reqHandler.getHandler(api, endpoint.GET_TRANSACTION_HISTORY, { ...payload }, authPrerequist);
    return dispatch(fetchTransactionsSuccess({ ...response, ts: Date.now() }));
  } catch (err) {
    return dispatch(utils.isReducerLoading(DEFAULT_ACTION));
  }
};

const yesRequestStatementGenerate = (payload, otherParams = {}) => async (dispatch, getState, api) => {
  const { pdf = '' } = otherParams || {};
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    if (!pdf) {
      const response = await reqHandler.postHandler(api, endpoint.POST_YES_BANK_CARD_STATEMENT, payload, authPrerequist);
      dispatch(rootApiResponse(utils.successResponse(DEFAULT_ACTION, response.message)));
      return dispatch(yesRequestStatementGenerateSuccess(response));
    }
    return dispatch(yesRequestStatementGenerateSuccess({ status: false, pdf }));
  } catch (err) {
    dispatch(rootApiResponse(errorResponse(DEFAULT_ACTION, err)));
    return dispatch(utils.isReducerLoading(DEFAULT_ACTION));
  }
};

export { fetchTransactions, yesRequestStatementGenerate };



// WEBPACK FOOTER //
// client/containers/YesRequestStatement/actions.js